var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    stroke: "#A4A6B3",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92985 8.77376C6.92985 9.22949 7.20898 9.59408 7.80143 9.59408C8.34261 9.59408 8.49072 9.28646 8.74707 8.94466C8.97494 8.61426 9.23128 8.40918 9.60726 8.16423C10.251 7.75407 10.9517 7.28695 10.9517 6.19889C10.9517 4.78044 9.76107 4 8.08626 4C7.11214 4 6.38867 4.26204 5.95573 4.63802C5.6766 4.87728 5.5 5.19059 5.5 5.521C5.5 5.90267 5.75635 6.26725 6.26335 6.26725C6.54248 6.26725 6.71338 6.15332 6.93555 5.98812C7.19189 5.77165 7.49382 5.65202 7.83561 5.65202C8.29134 5.65202 8.75277 5.87988 8.75277 6.3527C8.75277 6.79704 8.354 7.0363 7.90397 7.361C7.27734 7.82243 6.92985 8.22689 6.92985 8.77376ZM6.63363 11.0239C6.63363 11.6506 7.14632 12.0322 7.77295 12.0322C8.38818 12.0322 8.90088 11.6506 8.90088 11.0239C8.90088 10.403 8.38818 10.0213 7.77295 10.0213C7.14632 10.0213 6.63363 10.403 6.63363 11.0239Z",
    fill: "#A4A6B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqMenuIcon);
export default __webpack_public_path__ + "static/media/faq-menu-icon.55dd9ea6a0bb90cc38806cd0944e411b.svg";
export { ForwardRef as ReactComponent };